import { CheckNotes, InspectionCase, SummaryNotes } from '../inspection-cases';
import { Cases, Inspection } from '../inspection.dto';
import { PlanningDetails } from '../planning-details.dto';
import { AerosolShutdownDesign } from './aerosol-shutdown-design.dto';

export class InspectionAerosolShutdownDto extends InspectionCase {
  aerosolShutdownDesign?: AerosolShutdownDesign;
  planningDetails?: PlanningDetails;
  summaryNotes?: SummaryNotes[];
}

export class InspectionAerosolShutdown
  extends InspectionAerosolShutdownDto
  implements Inspection
{
  constructor(
    data: InspectionAerosolShutdownDto = {
      title: 'בדיקת כיבוי באמצעות ארוסול',
      isApplicable: true,
      summaryNotes: []
    }
  ) {
    super(data);
    this.summaryNotes = data.summaryNotes;
    this.planningDetails = new PlanningDetails(data.planningDetails);
    this.aerosolShutdownDesign = new AerosolShutdownDesign(
      data.aerosolShutdownDesign
    );
  }

  setInspectionStatus(): void {
    this.aerosolShutdownDesign.setInspectionStatus();

    this.isPassed = this.aerosolShutdownDesign.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.aerosolShutdownDesign.getNotes()];
  }

  setAsApplicable?(): void {
    this.isApplicable = true;
    this.aerosolShutdownDesign.setAsApplicable();
  }

  getCases(): Cases[] {
    return [
      {
        title: this.aerosolShutdownDesign.title,
        cases: [
          this.aerosolShutdownDesign.main,
          this.aerosolShutdownDesign.areas[0].aerosol,
          this.aerosolShutdownDesign.areas[0].shutdownComponents,
          this.aerosolShutdownDesign.areas[0].installationRequirements,
          this.aerosolShutdownDesign.areas[0].markupRequirements
        ]
      }
    ];
  }
}
